import { useEffect } from "react";
import { Button, Drawer, Flex, Form, Grid } from "antd";
import ProductQuickForm from "./ProductQuickForm";
import "./productDrawer.css"
import { useDispatch } from "react-redux";
import { fetchItemCode } from "../../itemManageThunks";

const ProductQuickDrawer = ({ open, onClose, onCreated, fromServiceEntry= false }) => {
  const [form] = Form.useForm();
  const screens = Grid.useBreakpoint();
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      form.resetFields();

      dispatch(fetchItemCode()).then((res) => {
        const code = res.payload;
        form.setFieldsValue({
          item_code: code,
          is_service: fromServiceEntry || false
        });
      });
    }
  }, [open, fromServiceEntry, form, dispatch]);

  return (
    <Drawer
      open={open}
      title="Add Product"
      width={screens.md ? 560 : "100%"}
      styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      onClose={onClose}
      destroyOnClose
      bodyStyle={{
        paddingInline: screens.md ? 40 : 20,
        paddingBottom: 88,
      }}
      footer={
        <Flex justify="end" gap={12}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </Flex>
      }
    >
      <ProductQuickForm
       fromServiceEntry={fromServiceEntry} 
        form={form}
        onSuccess={(item) => {
          onCreated(item);
          onClose();
        }}
      />
    </Drawer>
  );
};

export default ProductQuickDrawer;